import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import OrderHistory from "./OrderHistory";

const MessageRow = styled.tr`
  text-align: center;
`;

const MessageTd = styled.td`
  padding: 20px;
  font-style: italic;
`;

const Container = styled.div`
  padding: 20px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  border-radius: 10px;
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 2px;
  background-color: white;
  overflow: hidden;
`;

const Th = styled.th`
  background-color: #3498db;
  color: white;
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
`;

const TimerTd = styled(Td)`
  color: ${(props) => (props.isCritical ? "red" : "black")};
`;

const Button = styled.a`
  padding: 8px 3px;
  margin: 6px;
  font-size: 14px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const ExpandedRow = styled.tr`
  background-color: #f9f9f9;
`;

const ExpandedTd = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 12px;
  color: #555;
`;

export default function OrdersMonitor() {
  const navigate = useNavigate();
  const [expandedOrderId, setExpandedOrderId] = useState(null); // 확장된 주문 상태
  const [orderHistories, setOrderHistories] = useState({  }); // 가짜 주문 이력 데이터를 저장
  const [agentOrders, setAgentOrders] = useState([ ]); // 가짜 주문 데이터를 저장



  useEffect(() => {
    const fetchAssignedOrders = async () => {
      try {
        const response = await fetch('/Acution/orders-monitor', {
          credentials: 'include',
        });
        const data = await response.json();
        setAgentOrders(data.map(order => ({
          ...order,
          remainingTime: calculateRemainingTime(order.expiration_time),
        })));
      } catch (error) {
        alert('Error fetching assigned orders:', error);
      }
    };
    fetchAssignedOrders();

    const intervalId = setInterval(() => {
      setAgentOrders((prevOrders) =>
        prevOrders.map((order) => {
          const remainingTime = calculateRemainingTime(order.expiration_time);
          return { ...order, remainingTime };
        })
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const calculateRemainingTime = (expirationTime) => {
    const end = new Date(expirationTime);
    const now = new Date();
    const diff = end - now;
  
    if (diff <= 0) return 'Expired';
  
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
  
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };
  
  const toggleExpandRow = async (menu_id) => {
    if (expandedOrderId === menu_id) {
      setExpandedOrderId(null);
    } else {
      if (!orderHistories[menu_id]) {
        const historyResponse = await fetch(
          `/Acution/order-history/${menu_id}`,
          {
            credentials: "include",
          }
        );
        const historyData = await historyResponse.json();
        setOrderHistories((prevHistories) => ({
          ...prevHistories,
          [menu_id]: historyData,
        }));
      }
      setExpandedOrderId(menu_id);
    }
  };

  return (
    <Container>
      <Title>전체 대행주문건</Title>
      <Table>
        <thead>
          <tr>
            <Th>주문번호</Th>
            <Th>영화제목</Th>
            <Th>상영관</Th>
            <Th>상영일자</Th>
            <Th>상영시간</Th>
            <Th>수량</Th>
            <Th>대행만료시간</Th>
            <Th>Action</Th>
          </tr>
        </thead>
        <tbody>
          {agentOrders.length === 0 ? (
            <MessageRow>
              <MessageTd colSpan="8">
                {" "}
                 대행 건 수가 없습니다.{" "}
              </MessageTd>
            </MessageRow>
          ) : (
            agentOrders.map((order) => (
              <React.Fragment key={order.menu_id}>
                <tr>
                  <Td>{order.menu_id}</Td>
                  <Td>{order.movie_title}</Td>
                  <Td>{order.theater}</Td>
                  <Td>{order.date}</Td>
                  <Td>{order.screening_time}</Td>
                  <Td>{order.viewer_count}</Td>
                  <TimerTd
                    isCritical={
                      order.remainingTime &&
                      order.remainingTime.split(":")[0] === "0" &&
                      parseInt(order.remainingTime.split(":")[1]) <= 2
                    }
                  >
                    {order.remainingTime}
                  </TimerTd>
                  <Td>
                    <Button onClick={() => toggleExpandRow(order.menu_id)}>
                      이력보기
                    </Button>
                  </Td>
                </tr>

                {expandedOrderId === order.menu_id && (
                  <ExpandedRow>
                    <ExpandedTd colSpan="8">
                      <OrderHistory orderHistories={orderHistories[order.menu_id]} />
                    </ExpandedTd>
                  </ExpandedRow>
                )}
              </React.Fragment>
            ))
          )}
        </tbody>
      </Table>
    </Container>
  );
}
